import React, { useState } from 'react';

import { Slider } from '@atlas/components';
import { CasinoPrimaryTile, ChipsItem, Icon, Label } from '@atlas/ui';

import { CDN_TYPE_CMS, imageUrlCDN } from 'src/common/utils';

const LobbyPrimaryBlock = ({ blockTitleKey, blocks, imageUrl }) => {
  const [swiper, setSwiper] = useState(null);
  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();
  const [isShowImg, toggleVisibilityImg] = useState(!!imageUrl);
  const handleError = () => toggleVisibilityImg(false);

  const finalItems = blocks || [];

  if (!finalItems || finalItems.length === 0) {
    return null;
  }

  return (
    <div className="casino-lobby__item lobby-primary">
      <div className="casino-lobby__header">
        <div className="casino-lobby__left">
          {isShowImg && (
            <div className="casino-lobby__icon">
              <img
                alt={blockTitleKey}
                height={32}
                onError={handleError}
                role="presentation"
                src={`${encodeURI(imageUrlCDN(imageUrl, CDN_TYPE_CMS))}`}
                width={32}
              />
            </div>
          )}
          {blockTitleKey && (
            <div className="casino-lobby__title">
              <Label message={blockTitleKey} />
            </div>
          )}
        </div>
        <div className="casino-lobby__right">
          <ChipsItem
            className="casino-lobby__arrow casino-lobby__arrow-left"
            label={<Icon name="arrow-left" />}
            onClick={prevSlide}
          />
          <ChipsItem
            className="casino-lobby__arrow casino-lobby__arrow-right"
            label={<Icon name="arrow-right" />}
            onClick={nextSlide}
          />
        </div>
      </div>
      <div className="casino-lobby__content">
        <div className="lobby-primary__slider">
          <Slider
            breakpoints={{
              1: {
                slidesPerView: 6,
              },
              1000: {
                slidesPerView: 8,
              },
              1250: {
                slidesPerView: 10,
              },
              1550: {
                slidesPerView: 11,
              },
              850: {
                slidesPerView: 7,
              },
            }}
            breakpointsBase="container"
            direction="horizontal"
            onBeforeInit={setSwiper}
            slidesPerView={8}
            spaceBetween={8}
          >
            {finalItems.map((item, index) => (
              <Slider.Slide key={`${crypto.randomUUID()}`}>
                <CasinoPrimaryTile
                  index={index}
                  isLoading={false}
                  isMobile={false}
                  item={{
                    iconUrl:
                      'https://d1fojj4wte942r.cloudfront.net/e-games/luckypunch_onlyplay_direct_desktop_mobile_icon_1677234644490.webp',
                    id: '1' + index,
                    title: 'Smartico store',
                  }}
                />
              </Slider.Slide>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default LobbyPrimaryBlock;
